import qs from 'qs';
import instance from '../axios';

export const getFactors = () => {
  return instance.get('/catalogs/factors');
};

export const updateFactors = (factors) =>{
  return instance.put('/catalogs/factors', factors);
}